import React from "react";
import {
    MessageBubble,
    MessageUnreadBubble,
    MessageContainer,
    DatePersian,
    DatePersianRelative,
    BubbleContainer,
    LinkContainer,
  } from "./messageList.styles";
  import { toPersianNum, toSeperatedNum } from "../../assets/utils";
const MessageList = ({msgData,setMsgData}) => {
  return (
    <MessageContainer>
      {msgData
        ? msgData.map(({seen,content,links,date_persian,date_persian_relative}) =>
            seen ? (
              <BubbleContainer>
                <DatePersian>{toPersianNum(date_persian)}</DatePersian>
                <MessageBubble>
                  {content}
                  {links.length != 0
                    ? links.map(({url,action}) => (
                        <a href={url} target="_blank">
                          <LinkContainer>{action}</LinkContainer>
                        </a>
                      ))
                    : ""}
                  <DatePersianRelative>
                    {toPersianNum(date_persian_relative)}
                  </DatePersianRelative>
                </MessageBubble>
              </BubbleContainer>
            ) : (
              <BubbleContainer>
                <DatePersian>{toPersianNum(date_persian)}</DatePersian>
                <MessageUnreadBubble>
                  {content}
                  {links.length != 0
                    ? links.map(({url,action}) => (
                        <a href={url} target="_blank">
                          <LinkContainer>{action}</LinkContainer>
                        </a>
                      ))
                    : ""}
                  <DatePersianRelative>
                    {toPersianNum(date_persian_relative)}
                  </DatePersianRelative>
                </MessageUnreadBubble>
              </BubbleContainer>
            )
          )
        : ""}
    </MessageContainer>
  );
};

export default MessageList;
